import React from 'react';
import { Box, Flex, Text, Icon } from '@chakra-ui/react';
import { FiInfo } from 'react-icons/fi';
import SendTemplateButton from './SendTemplateButton';

/**
 * Shown at the top of a thread that WE started and the customer has never
 * written into.
 *
 * ★ IT EXPLAINS A LOCKED COMPOSER, AND THAT IS ITS ONLY JOB.
 * An agent who starts a chat and then finds the message box disabled has no way
 * of knowing that the rule is Meta's, not ours. Without this the feature reads
 * as broken the moment it is used for the first time — which is every first
 * time.
 *
 * The 24-hour window opens only when the CUSTOMER writes to us, so a thread we
 * opened has no window at all until they reply. That is a different state from
 * an expired window and says so in different words: "cannot start" rather than
 * "reopen".
 *
 * Not a `Blocked` strip from the composer: this belongs with the (empty)
 * message list, above the composer's own explanation, and the two are read
 * together.
 */
export default function NewConversationBanner({ customerName, conversationId }) {
	const who = customerName ? customerName : 'this customer';
	return (
		<Flex justify="center" px="4" py="6">
			<Flex
				maxW="440px"
				align="flex-start"
				px="4"
				py="3"
				borderRadius="lg"
				bg="info.subtle"
				borderLeftWidth="3px"
				borderLeftColor="info"
			>
				<Icon as={FiInfo} color="info" mt="0.5" mr="3" flexShrink={0} />
				<Box>
					<Text fontSize="sm" fontWeight="medium" color="text.primary">
						Waiting for {who} to reply
					</Text>
					<Text fontSize="xs" color="text.secondary" mt="1" lineHeight="1.6">
						WhatsApp only lets a business open a conversation with an approved message template, so
						nothing can be typed here yet. As soon as they message you, you have 24 hours to reply
						freely.
					</Text>
					{/* The template it just named, offered rather than described. */}
					<Box mt="3">
						<SendTemplateButton conversationId={conversationId} size="xs" variant="solid" />
					</Box>
				</Box>
			</Flex>
		</Flex>
	);
}
